import React from 'react'
import "./tiles.css"
export default function Tiles(props) {
    return (
        <div className="card card-none-border">
            <div className="card-body card-bd">
                <div className='img-cntainer'>
                    <img  className='img-section my-2' src={props.icon} width={60} height={58} />
                </div>
                <div className='mt-1 card-title'>{props.title}</div>
            </div>
        </div>
    )
}
